import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaRegCircleUser } from "react-icons/fa6";
import { FiPhone } from "react-icons/fi";
import { GrLocation } from "react-icons/gr";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { MdOutlineMail } from "react-icons/md";
import { TbBuildingHospital } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  defaultProfile,
  njhsLogo,
  pendingCases,
  totalReferralCase
} from "../../../assets/constant";
import { Get } from "../../../AxiosCRUDFunctions";
import Button from "../../../components/Button";
import CarouselComponent from "../../../components/CarouselComponent";
import CommonCard from "../../../components/CommonCard";
import Navbar from "../../../components/Navbar";
import { BaseURL } from "../../../config";
import { formatPhoneNumber } from "../../../helpers";
import UpdatePasswordModal from "../../../modals/UpdatePasswordModal";
import { logout } from "../../../store/authSlice";
import classes from "./Dashboard.module.css";

const Dashboard = () => {
  const { token, isPasswordUpdated } = useSelector((state) => state?.authReducer);
  const dispatch = useDispatch();
  const date = new Date();
  const formattedDate = moment(date).format("MMM, YYYY");
  const [user, setUser] = useState(null);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);

  const [updatePasswordData, setUpdatePasswordData] = useState({
    currentPassword: "",
    password: "",
    confirmPassword: "",
  });


  const loadProfile = async () => {
    const response = await Get(BaseURL("SignUp/LoadDashboardData"), token);
    if (response != undefined && response?.data?.headers.error === 200) {
      setUser(response?.data?.body);
    } else {
      toast.error(response?.data.headers?.message);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const guidelines = [
    {
      id: 1,
      title:
        "Pallor with palpitation, persistent fatigue and shortness of breath",
    },
    {
      id: 2,
      title: "Unexplained and recurrent fever",
    },
    {
      id: 3,
      title: "Persistent bone and Joint pain and Back pain",
    },
    {
      id: 4,
      title: "Unexplained Bleeding",
    },
    {
      id: 5,
      title: "Unexplained weight loss, excessive sweating",
    },
    {
      id: 6,
      title: "Unexplained persistent or recurrent infection",
    },
    {
      id: 7,
      title: "Generalized Lymphadenopathy",
    },
    {
      id: 8,
      title: "Unexplained Petechiae",
    },
    {
      id: 9,
      title: "Unexplained Bruising",
    },
    {
      id: 10,
      title: "Hepatosplenomegaly",
    },
  ];

  const cancelHandler = () => {
    setShowUpdatePassword(false);
    setUpdatePasswordData({
      currentPassword: "",
      password: "",
      confirmPassword: "",
    });
  };
  const logoutHandler = () => {
    dispatch(logout());
  };

  useEffect(() => {
    if (isPasswordUpdated) {
      setShowUpdatePassword(true);
    }
    else {
      setShowUpdatePassword(false);
    }
  }, [])


  return (
    <>
      <div>
        <Navbar title={"NIBD HealthBridge"} />
        <Row
          className={[classes["cards-section"], classes["first-card"]].join(
            " "
          )}
        >
          <Col lg={9} md={12} sm={12} style={{}}>
            <CommonCard className={classes["commonCard-extra"]}>
              {user ? (
                <Row>
                  <Col lg={4} md={4} sm={4} className={classes["profile-img"]}>
                    <img
                      src={user?.image ? user?.image : defaultProfile}
                      alt="profile"
                    />
                  </Col>
                  <Col
                    lg={8}
                    md={8}
                    sm={8}
                    className={classes["details-wrapper"]}
                  >
                    <Row style={{ marginBottom: "20px" }}>
                      <Col className={classes[""]} lg={12} md={12} sm={12}>
                        <div className={classes["main-heading"]}>
                          <h1>
                            {user?.consultantName &&
                              (user?.consultantName?.includes("Dr")
                                ? user?.consultantName
                                : `Dr. ${user?.consultantName}`)}
                          </h1>
                          <p>{user?.qualification}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {user?.speciality && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <FaRegCircleUser
                                size={20}
                                style={{ marginTop: "2px" }}
                                className={classes["speciality-svg"]}
                              />
                              <p>{user?.speciality}</p>
                            </div>
                          </Row>
                        )}
                        {user?.email && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <MdOutlineMail />
                              <p>{user?.email}</p>
                            </div>
                          </Row>
                        )}
                        {user?.hospitalName && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <TbBuildingHospital />
                              <p>{user?.hospitalName}</p>
                            </div>
                          </Row>
                        )}
                      </Col>
                      <Col>
                        {user?.clinicName && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <HiOutlineOfficeBuilding />
                              <p>{user?.clinicName}</p>
                            </div>
                          </Row>
                        )}
                        {user?.phoneNo && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <FiPhone />
                              <p>{formatPhoneNumber(user?.phoneNo)}</p>
                            </div>
                          </Row>
                        )}
                        {user?.province && user?.city && (
                          <Row>
                            <div className={classes["single-detail"]}>
                              <GrLocation />
                              <p>
                                {user?.city}, {user?.province}
                              </p>
                            </div>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                "Loading...."
              )}
            </CommonCard>
          </Col>
          <Col lg={3} md={12} sm={12} className={classes["caseCard-wrapper"]}>
            <CommonCard className={classes["caseCard"]}>
              <Row>
                <Col xl={4} sm={4} className={classes["cases-picture-card"]}>
                  <img src={totalReferralCase} alt="profile" />
                </Col>
                <Col xl={8} sm={8}>
                  <div className={classes["case-card-heading"]}>
                    <h1>My Referral Cases</h1>
                    <div className={classes["sub-headings"]}>
                      <p style={{ fontSize: "28px", fontWeight: "500" }}>
                        {user?.totalReferralCases}
                      </p>
                      <p>{formattedDate}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </CommonCard>
            <CommonCard className={classes["caseCard"]}>
              <Row>
                <Col sm={4} className={classes["cases-picture-card"]}>
                  <img src={pendingCases} alt="profile" />
                </Col>
                <Col sm={8}>
                  <div className={classes["case-card-heading"]}>
                    <h1>Pending Cases</h1>
                    <div className={classes["sub-headings"]}>
                      <p style={{ fontSize: "28px", fontWeight: "500" }}>
                        {user?.totalPendingCases}
                      </p>
                      <p>{formattedDate}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </CommonCard>
          </Col>
        </Row>
        <div className={classes["carousal-wrapper"]}>
          <Row>
            <h1 className={classes["Carousel-heading"]}>Our Expertise</h1>
          </Row>
          <CarouselComponent />
        </div>
        <div
          className={classes["cards-section"]}
          style={{ marginBottom: "20px" }}
        >
          <CommonCard className={classes["njhs-card-extraStyles"]}>
            <Row>
              <Col
                className={classes["njhs-logo-wrapper"]}
                xl={2}
                lg={3}
                md={5}
                sm={12}
              >
                <img src={njhsLogo} alt="logo" />
              </Col>
              <Col
                className={classes["njhs-description"]}
                xl={10}
                lg={9}
                md={7}
                sm={12}
              >
                <p>
                  National Journal of Health Sciences (NJHS) aims to provide a
                  platform that will construct substantial and reliable
                  involvement of the scientific community. NJHS will publish
                  scholarly articles as Open Access related to broad spectrum of
                  research disciplines.
                </p>
                <div className={classes["visit-wrapper"]}>
                  <p>To gather further information, please visit our website</p>
                  <Button
                    className={classes["btn"]}
                    onClick={() => window.open("https://njhsciences.com/")}
                  >
                    Visit Website
                  </Button>
                </div>
              </Col>
            </Row>
          </CommonCard>
        </div>
        <div
          className={classes["cards-section"]}
          style={{ marginBottom: "20px" }}
        >
          <CommonCard
            className={[
              classes["njhs-card-extraStyles"],
              classes["cards-guideline-section"],
            ].join(" ")}
          >
            <div className={classes["main-heading"]}>
              <h1>Referral Guidelines</h1>
              <span>
                The following clinical features are highly suggestive of blood
                disease (both benign and malignant)
              </span>
            </div>
            <div className={classes["details"]}>
              <ul>
                {guidelines?.map((item) => (
                  <li key={item.id}>{item.title}</li>
                ))}
              </ul>
            </div>
            <div className={classes["main-heading"]}>
              <span>
                It is advised to go for CBC Test from any reputable clinical
                Laboratory and if any CBC parameter is out of normal range
                kindly refer that patient to a clinical hematology setup.
              </span>
            </div>
          </CommonCard>
        </div>
      </div>
      <UpdatePasswordModal
        show={showUpdatePassword}
        setShow={logoutHandler}
        cancelHandler={cancelHandler}
        data={updatePasswordData}
        setData={setUpdatePasswordData}
        isSetting={false}
      />
    </>
  );
};

export default Dashboard;
